import { Component, OnInit, Inject } from '@angular/core';
import { HsgModalDefault, HsgModalRef, HSG_MODAL_DATA, HsgModalDefaultData } from '@hhsg/hsg-asc';
import { Router } from '@angular/router';

@Component({
  selector: 'smt-another-user-modal',
  templateUrl: './another-user-modal.component.html',
  styleUrls: ['./another-user-modal.component.scss']
})
export class AnotherUserModalComponent extends HsgModalDefault {
  constructor(
		public modalRef: HsgModalRef<HsgModalDefault>,
    @Inject(HSG_MODAL_DATA) public data: HsgModalDefaultData,
    private _route: Router
	) {
    super(modalRef,data);
  }
  ngOnInit(): void {
    this.modalRef.afterClosed().subscribe((data) => {
      if (data === undefined) {
        this._route.navigateByUrl(this.data['acceptLink']);
      }
    });
  }

  reloadPage() {
    window.location.reload();
  }
}
